import { PlainIconButton } from "@tvg/fuse-buttons";
import styled from "styled-components";

export const StyledPlainIconButton = styled(PlainIconButton)`
  justify-self: end;
  align-self: center;
`;
